export enum CurrencyType {
  USD = 0,
  CAD = 1,
  MXN = 2,
  CRC = 3,
}
